import Modal2 from 'components/commons/modal/Modal2';
import React from 'react';

export const TargetCountIsMaxModal = ({
  hide,
  isShow,
}: {
  isShow: boolean;
  hide: () => void;
}): React.ReactElement => {
  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto">
          <div className="flex flex-row">
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="font-bold text-bluegray-700 text-base">
            目標の数が上限に達しています。
          </div>
          <div className="text-sm mt-4">
            登録されている目標の数が上限数（5件）に達しています。
            <br />
            新しく目標を作成する場合は既存の目標の削除が必要になります。
          </div>
          <button
            className="mt-2 p-2 font-bold text-bluegray-550 justify-center w-full text-base"
            onClick={hide}>
            閉じる
          </button>
        </div>
      </Modal2>
    </>
  );
};
